import React from 'react';
import ProyectoTab from '../../../components/ProyectoTab';

const TabContent = ({ activeTab, currentViewData, onOpenPhotos, mapInstance }) => {
  const renderTabContent = () => {
    switch (activeTab) {
      case 'proyecto':
        return <ProyectoTab currentViewData={currentViewData} onOpenPhotos={onOpenPhotos} mapInstance={mapInstance} />;
      default:
        return null;
    }
  };

  return (
    <div className="p-4">
      {renderTabContent()}
    </div>
  );
};

export default TabContent;
